import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonChipStyled,
  IconChipAdornmentStyled,
} from './styles';

// TODO: Expand functionality to chips to make them
// * dismissable (with a close icon)
// * optionally clickable (chips can be used as static filter/info displays, for example.)

export const ChipComponent = ({
  className,
  icon,
  id,
  onClick,
  text,
}) => (
  <ButtonChipStyled
    className={className}
    id={id}
    onClick={onClick}
    type='button'>
    {icon && (
      <IconChipAdornmentStyled
        variant={icon}
        text={text} />
    )}
    {text}
  </ButtonChipStyled>
);

ChipComponent.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default ChipComponent;
